import Vue from 'vue'
import './plugins/axios'
import './plugins/flags'
import './plugins/video'
import './plugins/numeric'
import './plugins/device'
import './plugins/mask'
import './plugins/carousel'
import './plugins/charts'
import './plugins/maps'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
